export const Integrations = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.29232 5.20866H5.62565C4.70518 5.20866 3.95898 5.95485 3.95898 6.87533V11.8753C3.95898 13.7163 5.45137 15.2087 7.29232 15.2087H10.0007M7.29232 5.20866V2.29199M7.29232 5.20866H12.709M12.709 5.20866H14.3757C15.2961 5.20866 16.0423 5.95485 16.0423 6.87533V11.8753C16.0423 13.7163 14.5499 15.2087 12.709 15.2087H10.0007M12.709 5.20866V2.29199M10.0007 15.2087V17.7087"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Integrations
